import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        isOpen: false,
        message: '',
        type: 'success', // 'success', 'error', 'info'
    }),
    actions: {
        show(message, type = 'success') {
            this.message = message;
            this.type = type;
            this.isOpen = true;
            // إغلاق تلقائي بعد 3 ثوانٍ إذا أردت
            setTimeout(() => this.close(), 4000);
        },
        close() {
            this.isOpen = false;
        }
    }
});